export default __webpack_public_path__ + "static/media/toys.644d74db.svg";